import React from "react";
import { DatePicker as MuiDatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { TextField } from "@mui/material";

const DatePicker = ({
  helperText,
  error,
  onAccept,
  value,
  onChange,
  disabled,
  minDate,
  onBlur,
  label,
  inputDataTestId,
  variant,
  size,
  ...other
}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <MuiDatePicker
        onAccept={onAccept}
        clearable
        value={value}
        format="MM/dd/yyyy"
        onChange={onChange}
        fullWidth
        disabled={disabled}
        minDate={minDate}
        KeyboardButtonProps={{ color: !!error ? "inherit" : "default" }}
        renderInput={params => (
          <TextField
            variant="filled"
            size={size}
            fullWidth
            {...params}
            helperText={helperText}
            error={error}
            disabled={disabled}
            onBlur={onBlur}
            label={label}
            hiddenLabel={!label}
            {...other}
            inputProps={{
              "data-testid": inputDataTestId,
              ...params.inputProps
            }}
          />
        )}
      />
    </LocalizationProvider>
  );
};

export default DatePicker;
